module.exports = "../study/imgs/maps/Tokyo/S8/WaterEnvironment/Chlmax/Tokyo_Chlmax_MRI_RCP85_Mid.png";